/* CG: on mobile, send shoppers straight to the cart after Add to Cart (2026-07-23 v4) */
(function () {
  var MQ = '(max-width: 767px)';
  function isMobile() { return window.matchMedia(MQ).matches; }
  var redirected = false;
  function goToCart() {
    if (redirected || !isMobile()) return;
    redirected = true;
    window.location.href = '/cart';
  }
  function watchCartIncrease() {
    if (!isMobile()) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (start) {
        var startCount = start.item_count;
        var tries = 0;
        var iv = setInterval(function () {
          tries++;
          fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (c) {
              if (c.item_count > startCount) { clearInterval(iv); goToCart(); }
              else if (tries >= 14) { clearInterval(iv); }
            })
            .catch(function () { clearInterval(iv); });
        }, 350);
      })
      .catch(function () {});
  }
  function isAddControl(el) {
    return el && el.closest && el.closest('button[name="add"], .product-form__cart-submit, [data-add-to-cart]');
  }
  function init() {
    document.addEventListener('click', function (e) {
      if (isMobile() && isAddControl(e.target)) watchCartIncrease();
    }, true);
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (isMobile() && f && f.getAttribute && (f.getAttribute('action') || '').indexOf('/cart/add') !== -1) watchCartIncrease();
    }, true);
    ['.purchase-confirmation-popup', '.quick-cart'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      new MutationObserver(function () { if (el.classList.contains('active')) goToCart(); })
        .observe(el, { attributes: true, attributeFilter: ['class'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
